




















import Native from "@/common/Native";
import { Row, Col } from "vant";
import { Component, Vue, Prop } from "vue-property-decorator";
import wx from "weixin-js-sdk"; // 引入wx
import VConsole from "vconsole";
@Component({})
export default class NewsMultiple extends Vue {
  @Prop()
  private newsInfo: any;
  mounted() {
    // let vConsole = new VConsole();
  }
  getSrc(filePath: string) {
    let src = "";
    if (filePath.includes(".zip")) {
      src = "zip";
    } else if (filePath.includes(".pdf")) {
      src = "pdf";
    } else if (filePath.includes(".docx") || filePath.includes(".doc")) {
      src = "word";
    } else if (filePath.includes(".xlsx") || filePath.includes(".xls")) {
      src = "excel";
    } else if (filePath.includes(".ppt") || filePath.includes(".pptx")) {
      src = "ppt";
    } else if (filePath.includes(".rar")) {
      src = "rar";
    }
    return src;
  }
  getFile(file: any) {
    if (Native.isOpenInApp()) {
      const params = {
        isShare: true,
        fileUrl: file.filePath,
        fileName: file.fileName
      };
      if (ZWY_CLOUD.getOS() == "iOS" && ZWY_CLOUD.getWebVersion(1)) {
        return (window as any).webkit.messageHandlers.xhlShareFile.postMessage(
          JSON.stringify(params)
        );
      }
      return (window as any).AppJsObj.xhlShareFile(JSON.stringify(params));
    } else {
      // console.log(file)
      if (this.$route.query.appId == "16") {
        window.open(file.filePath);
      } else {
        this.$emit("wxopenApp");
      }
      // wx.downloadFile({
      //   // 示例 url，并非真实存在
      //   url: file.filePath,
      //   success: function(res) {
      //     const filePath = res.tempFilePath;
      //     wx.openDocument({
      //       filePath: filePath,
      //       success: function(res) {
      //         console.log("打开文档成功");
      //       }
      //     });
      //   }
      // });
    }
  }
}
